import template from './access-type.jade';
import accessTypeOptions from '../../../enums/access-type';

export default angular.module('cian.addForm.accessType', []).directive('cianAfAboutBuildingAccessType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.options = accessTypeOptions;
  },
  controllerAs: 'accessType',
  template,
})).name;
